function SkeletonBox({ w = '100%', h = 20, r = 10, style = {} }) {
  return (
    <div
      className="skeleton-shimmer"
      style={{ width: w, height: h, borderRadius: r, ...style }}
    />
  )
}

export default function DashboardSkeleton() {
  return (
    <div style={{ padding: '0 16px 80px', paddingTop: 4 }}>
      {/* User profile */}
      <div style={{
        display: 'flex', gap: 14, alignItems: 'center',
        background: '#141414', borderRadius: 20, padding: '14px 16px', marginBottom: 20,
      }}>
        <SkeletonBox w={58} h={58} r={50} />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
          <SkeletonBox w="55%" h={15} />
          <SkeletonBox w="35%" h={11} />
          <SkeletonBox w="45%" h={11} />
        </div>
      </div>

      {/* Tabs */}
      <SkeletonBox h={44} r={12} style={{ marginBottom: 14 }} />

      {/* Stats cards */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8, marginBottom: 10 }}>
        <SkeletonBox h={62} r={12} />
        <SkeletonBox h={62} r={12} />
        <SkeletonBox h={62} r={12} />
      </div>

      {/* Chart */}
      <SkeletonBox h={190} r={16} style={{ marginBottom: 10 }} />

      {/* KPI row 1 */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8, marginBottom: 8 }}>
        <SkeletonBox h={62} r={12} />
        <SkeletonBox h={62} r={12} />
        <SkeletonBox h={62} r={12} />
      </div>

      {/* KPI row 2 */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
        <SkeletonBox h={62} r={12} />
        <SkeletonBox h={62} r={12} />
      </div>
    </div>
  )
}
